export const loadScript = async url => {
  const script = document.createElement('script');
  script.src = url;
  script.async = false; // This is required for synchronous execution
  script.setAttribute('data-manual-render', 'true');
  script.setAttribute('data-zone-id', '231260');
  document.head.appendChild(script);
};
